import './UserProfile.scss';
import { Card } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../stores/globalStore';
import UserEditPrefs from './UserEditPrefs';
import UserEditPassword from './UserEditPassword';

function UserProfile() {
  const { t } = useTranslation();

  const connectedUser = useSelector((state: RootState) => state.authentication.connectedUser);

  return (
    <div className="user-profile">
      <div className="category-container">
        <Card>
          <div className="card-title">
            <FontAwesomeIcon className="title-icon" icon={faUserCircle} />&nbsp;
            {t('UserProfile.myProfile')}
          </div>
          <div>
            <div className="dual-container">
              <div>
                {t('UserProfile.name')}
                {' '}
                :
              </div>
              <div>{connectedUser.name}</div>
            </div>
            <div className="dual-container">
              <div>
                {t('UserProfile.email')}
                {' '}
                :
              </div>
              <div>{connectedUser.email}</div>
            </div>
            <div className="dual-container">
              <div>
                {t('UserProfile.role')}
                {' '}
                :
              </div>
              <div>{connectedUser.role}</div>
            </div>
          </div>
          <div style={{ marginTop: 15, marginBottom: 15 }}>
            <hr />
          </div>
          <div className="dual-container">
            <div>
              {t('UserProfile.prefs.lang')}
              {' '}
              :
            </div>
            <div>{t(`UserProfile.${connectedUser.prefs?.lang}`)}</div>
            <div>
              {t('UserProfile.prefs.nbRow')}
              {' '}
              :
            </div>
            <div>{connectedUser.prefs?.nbRow}</div>
          </div>
        </Card>
      </div>
      <div className="category-container">
        <UserEditPassword />
        <UserEditPrefs connectedUser={connectedUser} />        
      </div>
    </div>
  );
}

export default UserProfile;
